(() => {
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-social-config]').textContent);
    const q = (s) => root.querySelector(s);
    const form = q('form'), model = q('[data-model]'), file = q('[data-file]');
    const styles = [...root.querySelectorAll('[data-style]')];
    const setQuantity = 2;
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100) + ' ' + (config.currency || 'USD');
    const submit = q('[data-submit]'), error = q('[data-error]'), preview = q('[data-preview]');
    const fileStatus = q('[data-file-status]'), removeFile = q('[data-remove-file]'), progress = q('[data-progress]');
    let busy = false, imageReady = false, objectUrl = null, generation = 0;
    const showError = (message) => { error.textContent = message; error.hidden = false; };
    const selected = () => {
      const type = styles.find((input) => input.checked)?.value;
      const style = type && config[type];
      return { style, variant: style?.variants.find((v) => v.model === model.value && v.available) };
    };
    const placeholder = model.options[0].cloneNode(true);
    let modelStyle;
    const update = () => {
      const type = styles.find((input) => input.checked)?.value || '';
      if (type !== modelStyle) {
        const previous = model.value;
        const variants = type ? config[type].variants : styles.flatMap((input) => config[input.value].variants);
        const models = [...new Set(variants.filter((variant) => variant.available).map((variant) => variant.model))];
        model.replaceChildren(placeholder.cloneNode(true), ...models.map((name) => new Option(name, name)));
        model.value = models.includes(previous) ? previous : '';
        modelStyle = type;
      }
      styles.forEach((input) => {
        const v = config[input.value].variants.find((v) => v.model === model.value && v.available);
        input.disabled = !config[input.value].variants.some((variant) => variant.available);
        if (input.disabled) input.checked = false;
        const price = q(`[data-style-price="${input.value}"]`);
        const pricedVariant = v || config[input.value].variants.find((variant) => variant.available);
        price.textContent = pricedVariant ? money(pricedVariant.priceCents * 2) : config.messages.unavailable;
      });
      const { style, variant } = selected();
      q('[data-variant]').value = variant?.id || '';
      q('[data-model-property]').value = model.value;
      q('[data-style-property]').value = style?.label || '';
      q('[data-contents-property]').value = style?.contents || '';
      q('[data-selection]').textContent = variant ? `${model.value} · ${style.label}` : config.messages.selectHelp;
      q('[data-price]').textContent = variant ? money(variant.priceCents * setQuantity) : '';
      q('[data-quantity-summary]').textContent = variant ? config.messages.quantitySummary.replace('__QUANTITY__', setQuantity).replace('__PRICE__', variant.price) : '';
      q('[data-contents]').textContent = variant ? style.contents : '';
      progress.textContent = !style ? config.messages.needStyle : !variant ? config.messages.needModel : !imageReady ? config.messages.needFile : !q('[data-consent]').checked ? config.messages.needConsent : config.messages.readyOrder;
      progress.dataset.complete = String(!!variant && imageReady && q('[data-consent]').checked);
      submit.disabled = busy;
      form.setAttribute('aria-busy', String(busy));
    };
    file.addEventListener('change', () => {
      const revision = ++generation;
      imageReady = false;
      q('[data-preview-wrap]').hidden = true;
      fileStatus.hidden = true;
      removeFile.hidden = true;
      update();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      const f = file.files[0];
      if (!f || f.size === 0 || f.size > 20 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(f.type)) {
        file.setCustomValidity(config.messages.file);
        showError(config.messages.file);
        return;
      }
      file.setCustomValidity(config.messages.image);
      objectUrl = URL.createObjectURL(f);
      preview.onload = () => {
        if (revision !== generation) return;
        imageReady = true;
        file.setCustomValidity('');
        error.hidden = true;
        q('[data-preview-wrap]').hidden = false;
        fileStatus.textContent = config.messages.readyFile;
        fileStatus.hidden = false;
        removeFile.hidden = false;
        update();
      };
      preview.onerror = () => {
        if (revision !== generation) return;
        file.setCustomValidity(config.messages.image);
        showError(config.messages.image);
      };
      preview.src = objectUrl;
    });
    removeFile.addEventListener('click', () => {
      generation++;
      file.value = '';
      file.setCustomValidity('');
      imageReady = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      preview.removeAttribute('src');
      q('[data-preview-wrap]').hidden = true;
      fileStatus.hidden = true;
      removeFile.hidden = true;
      error.hidden = true;
      update();
      file.focus();
    });
    form.addEventListener('change', update);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      const { style, variant } = selected();
      let missing;
      if (!style) missing = [config.messages.errorStyle, styles.find(input => !input.disabled)];
      else if (!variant) missing = [config.messages.errorModel, model];
      else if (!imageReady) missing = [config.messages.errorScreenshot, file];
      else if (!q('[data-consent]').checked) missing = [config.messages.errorConsent, q('[data-consent]')];
      if (missing) { showError(missing[0]); missing[1]?.focus(); return; }
      if (!form.reportValidity()) return;
      busy = true;
      update();
      submit.textContent = config.messages.adding;
      error.hidden = true;
      q('[data-accepted-at]').value = new Date().toISOString();
      const data = new FormData(form);
      data.set('quantity', String(setQuantity));
      data.delete('screenshot_style');
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || config.messages.upload);
        const item = result.items?.[0] || result;
        if (!item.properties?.['Reference screenshot'] || item.properties?.['Customization and IP notice'] !== 'Agreed — SC-2026-10-12') throw new Error(config.messages.upload);
        location.assign(root.dataset.cartUrl);
      } catch (err) {
        showError(err.message || config.messages.upload);
        busy = false;
        submit.textContent = config.messages.add;
        update();
      }
    });
    form.noValidate = true;
    update();
  };
  const init = () => document.querySelectorAll('[data-social-custom]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();



